module.exports = __webpack_public_path__ + "static/media/certificate.8ff906e7.png";